import AbstractHover from './abstractHover';
import Contingent from './contingent';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';

export default class HoverSeat extends AbstractHover {
    renderTitle() {
        return (
            <Trans
                i18nKey="seat_info"
                values={{
                    row: this.props.zone.row,
                    seat: this.props.zone.seat,
                    access: this.props.zone.access
                }}
            >
                Access %access% Row %row% Seat %seat%
            </Trans>
        );
    }

    renderContent() {
        let { zone: seat } = this.props;
        const contingent = this.props.contingents.find(({ uuid }) => uuid === seat.contingent);

        if (!contingent) {
            return <Trans i18nKey="ticket.availability.no_contingent">No contingent</Trans>;
        }

        return <Contingent activeBooking={seat.booking} bookingState={seat.booking_state} contingent={contingent} />;
    }
}

HoverSeat.propTypes = {
    contingents: PropTypes.object.isRequired,
    zone: PropTypes.object.isRequired
};
